import { Flex, Heading } from '@chakra-ui/react';
import SettingsBreadcrumb from '../../components/SettingsBreadcrumb';
import GridRelatorios from './GridRelatorios/GridRelatorios';
import './relatorios.scss';

const Relatorios = () => {
  return (
    <Flex
      p="40px" 
      bgColor="#fafafa" 
      direction="column">
      <SettingsBreadcrumb /> 
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Relatórios
      </Heading>
    <GridRelatorios/>
    </Flex>
    
  );
};

export default Relatorios;
